import { uxConsts } from "../types/ux";

export const uxActions = {
  showProgress,
  hideProgress,
  hideToaster,
  showToaster
};

function showProgress(progressText: string) {
  return { type: uxConsts.SHOW_PROGRESS, progressText: progressText };
}

function hideProgress() {
  return { type: uxConsts.HIDE_PROGRESS };
}

function showToaster(
  message: string,
  variant: "success" | "info" | "warning" | "error",
  vertical: "top" | "bottom" = "bottom",
  horizontal: "left" | "center" | "right" = "right"
) {
  return {
    type: uxConsts.SHOW_TOASTER,
    toaster: {
      open: true,
      message: message,
      variant: variant,
      vertical,
      horizontal
    }
  };
}

function hideToaster() {
  return { type: uxConsts.HIDE_TOASTER };
}
